import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const projectflowBaseUrl = 'http://127.0.0.1:8002/api/1.0/flow/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const projectflowBaseUrl = baseDeployUrl + '/api/1.0/flow/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const handleApproveSubmit = (id, data, type) => {
  return axios.request({
    url: projectflowBaseUrl + type + '/approve/' + id,
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}
